import { fetchUserContext } from '@zola-helpers/client/dist/es/redux/user/userActions';

import { IUserContext } from '~/types/userContext';

export const getUserContext = async () => {
  return fetchUserContext() as Promise<IUserContext>;
};
